/* eslint-disable max-len */
import { UAE_CODE } from ".";

export const endpoints = {
  baseUrl: "http://conv.rakbankonline.ae/quickapply",
  appConfigUri: "/bbg-loans/api/v1/config",
  createProspectUri: "/bbg-loans/api/v1/usertypes/:userType/prospects",
  getProspectUri: "/bbg-loans/api/v1/usertypes/:userType/prospects/:prospectId",
  updateProspectUri: "/bbg-loans/api/v1/usertypes/sme/prospects/:prospectId",
  getProspectDocumentsUri: "/bbg-loans/api/v1/prospects/:prospectId/documents",
  uploadDocumentUri: "/bbg-loans/api/v1/prospects/:prospectId/documents",
  reuploadDocumentUri: "/bbg-loans/api/v1/prospects/:prospectId/documents",
  searchProspectUri: "/bbg-loans/api/v1/usertypes/:userType/prospects/search",
  getDocumentByIdUri: "/rest/v1/banks/RAK/prospectId/:prospectId/documents/:documentKey",
  screenProspectUri: "/bbg-loans/api/v1/prospects/:prospectId/screening",
  otpUri: "/bbg-loans/api/v1/otp",
  authenticateUserUri: "/bbg-loans/api/v1/users/authenticate",
  logoutUri: "/bbg-loans/api/v1/logout",
  docUploaderUri: "/rest/v1/banks/RAK/prospectId/:prospectId/documents",
  searchUserProspectUri: "/bbg-loans/api/v1/usertypes/sme/prospects/appsearch",
  createInviteUri: "/bbg-loans/api/v1/agent/createInvite",
  getTokenUri: "/bbg-loans/api/v1/oauth/token-new",
  sendAecbFtsEmailUri: "/bbg-loans/api/v1/usertypes/sme/prospects/:prospectId/sendAecbAndFtsEmail",
  getSignatoryInfo:
    "/bbg-loans/api/v1/usertypes/sme/prospects/:prospectId/signatories/:signatoryId",
  authorizeSignatory:
    "/bbg-loans/api/v1/usertypes/sme/prospects/:prospectId/signatories/:signatoryId/updateAECBandFTSConsent",
  updateByRO: "/bbg-loans/api/v1/usertypes/sme/RO/prospects/:prospectId",
  sendAdhocEmailUri: "/bbg-loans/api/v1/usertypes/sme/prospects/:prospectId/sendAdhocEmail",
  getDatalistSearchUri: "/bbg-loans/api/v1/codeType/:codetype/likeSearch/:searchPattern",
  postAuthToken: "/api/v1/onboarding/post-login/oauth2/token",
  documentUploaderToken: "/api/v1/onboarding/document/oauth2/token"
};
export const UPLOAD_PATH_UAT = "https://doc-uploader-sit.rakbanktst.ae/docuploader";
export const API_PATH = "http://conv.rakbankonline.ae/quickapply";

export const prospect = {
  applicantInfo: {
    fullName: "",
    email: "",
    countryCode: UAE_CODE,
    mobileNo: ""
  },
  generalInfo: {
    prospectId: "",
    cifId: "",
    customerType: "",
    dsaId: "",
    groupId: "",
    groupName: "",
    rmCode: "",
    accountManagerId: "",
    isPoliticallyExposed: ""
    // Enable it once we have this on DEH
    // contextType: "CUSTOMER"
  },
  applicationInfo: {
    viewId: "",
    islamicBanking: false,
    financeType: "",
    rakValuePackage: "",
    leadNumber: "",
    riskScore: "0.0",
    srNumber: "",
    channelId: "",
    channelType: "",
    createdDate: "",
    lastModifiedDate: "",
    createdBy: "",
    lastModifiedBy: "",
    actionType: "",
    saveType: "",
    tncAgreed: false,
    declaration: false
  },
  accountInfo: [
    {
      branchId: "",
      accountType: "",
      accountSubType: "",
      accountNo: "",
      accountCurrencies: [],
      accountCurrency: "",
      accountPurpose: "",
      debitCardApplied: false,
      chequeBookApplied: false,
      eStatements: false,
      mailStatements: false,
      receiveInterest: false,
      deliverByCourier: false
    }
  ],
  organizationInfo: {
    screeningInfo: {
      statusOverAll: "",
      screeningResults: []
    },
    branchCity: "",
    branchID: "",
    countryOfIncorporation: "",
    companyName: "",
    shortName: "",
    dateOfIncorporation: null,
    numberOfEmployees: 0,
    licenseType: "",
    licenseTypeOther: "",
    licenseIssuingAuthority: "",
    licenseNumber: "",
    licenseIssueDate: null,
    licenseExpiryDate: "",
    vatRegistrationNumber: "",
    addressInfo: [
      {
        typeOfAddress: "",
        officeAddressDifferent: "",
        addressDetails: [
          {
            addressFieldDesc: "",
            preferredAddress: "",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressLine4: "",
            poBox: "",
            emirateCity: "",
            country: "United Arab Emirates",
            typeOfSpaceOccupied: {
              spaceType: "",
              others: ""
            }
          }
        ]
      }
    ],
    contactDetails: {
      primaryMobileNo: "",
      primaryMobCountryCode: UAE_CODE,
      primaryEmail: "",
      primaryPhoneNo: "",
      primaryPhoneCountryCode: UAE_CODE,
      fax: "",
      faxCountryCode: "",
      secondaryPhoneNo: "",
      secondaryPhoneCountryCode: "",
      secondaryMobileNo: "",
      secondaryMobileCountryCode: "",
      secondaryEmail: "",
      website: ""
    },
    contactDetailsForTxnReconfirming: [
      {
        TxnReconfirmingfullname: "",
        primaryMobileNo: "",
        primaryMobCountryCode: "",
        primaryPhoneNo: "",
        primaryPhoneCountryCode: ""
      }
    ]
  },
  orgKYCDetails: {
    businessUnit: "",
    constitutionType: "",
    companyCategory: "",
    annualFinTurnoverAmtInAED: "",
    yearsInBusiness: 0,
    topCustomers: [
      {
        name: "",
        country: ""
      }
    ],
    topSuppliers: [
      {
        name: "",
        country: ""
      }
    ],
    topOriginGoodsCountries: [""],
    industryMultiSelect: [
      {
        industry: [""],
        subCategory: [""]
      }
    ],
    anticipatedTransactionsDetails: {
      totalMonthlyCashCreditsAED: {
        amountInFigures: "",
        inPercent: 0
      },
      totalMonthlyNonCashCreditsAED: {
        amountInFigures: "",
        inPercent: 0
      },
      totalMonthlyCreditsAED: "",
      maxAmtSingleTxnCashAED: "",
      maxAmtSingleTxnNonCashAED: ""
    },
    otherBankingRelationshipsInfo: {
      otherBankingRelationshipsExist: false,
      otherBankDetails: [
        {
          bankName: ""
        }
      ]
    },
    otherEntitiesInUAE: false,
    entitiesInUAE: [
      {
        companyName: "",
        emirate: "",
        tradeLicenseNo: ""
      }
    ],
    otherEntitiesOutsideUAE: false,
    entitiesOutsideUAE: [
      {
        companyName: "",
        country: ""
      }
    ],
    isDontHaveSuppliersYet: false,
    isDontTradeGoodsYet: false
  },
  signatoryInfo: [
    {
      screeningInfo: {
        statusOverAll: "",
        screeningResults: [
          {
            screeningType: "",
            screeningStatus: "",
            screeningFlag: "",
            screeningNotes: "",
            screeningReason: "",
            reasonNotes: "",
            reasonCode: "",
            reasonStatus: ""
          }
        ]
      },
      salutation: "",
      signatoryId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      shortName: "",
      fullName: "",
      gender: "",
      maritalStatus: "",
      maritalStatusOthers: "",
      occupation: "",
      mothersMaidenName: "",
      numberOfDependants: 0,
      highestEducationAttained: "",
      employmentStatus: "",
      kycVerified: false,
      kycDetails: {
        isShareholderACompany: false,
        salutation: "",
        shareholderPOASignatoryName: "",
        isSignatory: false,
        isShareholder: false,
        shareHoldingPercentage: 0,
        dateOfBirth: "",
        dualCitizenship: false,
        dualCitizenshipCountry: [""],
        residenceCountry: "",
        isUAEResident: false,
        passportDetails: [
          {
            passportNumber: "",
            passportExpiryDate: "",
            country: "",
            diplomatPassport: false,
            hasAnotherCitizenship: false
          }
        ],
        emirateIdDetails: {
          eidNumber: "",
          eidExpiryDt: ""
        },
        selfGovtPosition: "",
        relativeGovtPosition: "",
        isPEP: false,
        qualification: "",
        experienceInYrs: "",
        sourceOfWealth: [
          {
            wealthType: "",
            others: ""
          }
        ]
      },
      contactDetails: {
        primaryMobileNo: "",
        primaryMobCountryCode: UAE_CODE,
        primaryEmail: "",
        primaryPhoneNo: "",
        primaryPhoneCountryCode: UAE_CODE,
        fax: "",
        faxCountryCode: "",
        secondaryPhoneNo: "",
        secondaryPhoneCountryCode: "",
        secondaryMobileNo: "",
        secondaryMobileCountryCode: "",
        secondaryEmail: "",
        website: ""
      },
      employmentDetails: {
        employmentType: "",
        otherEmploymentType: "",
        designation: "",
        empNo: "",
        department: "",
        employerName: "",
        occupation: "",
        totalExperienceYrs: "",
        employmentStartDate: "",
        isPersonWorkAtCompany: false
      },
      sameAsCompanyAddress: false,
      addressInfo: [
        {
          typeOfAddress: "",
          addressDetails: [
            {
              addressFieldDesc: "",
              preferredAddress: "",
              addressLine1: "",
              addressLine2: "",
              addressLine3: "",
              addressLine4: "",
              poBox: "",
              emirateCity: "",
              country: "United Arab Emirates"
            }
          ]
        }
      ],
      accountSigningInfo: {
        accountSigningType: "",
        accountSigningInstn: "",
        authorityType: ""
      },
      debitCardInfo: {
        issueDebitCard: false,
        authSignatoryDetails: {
          fullNameOnPassport: "",
          nameOnDebitCard: ""
        }
      }
    }
  ],
  channelServicesInfo: {
    mobileInstructions: false,
    marketingSMS: false,
    doNotDisturbHours: "",
    weeklyBalanceNotification: "",
    monthlyBalanceNotification: 0
  },
  documents: {
    companyDocuments: [],
    stakeholdersDocuments: null,
    otherDocuments: []
  },
  prospectStatusInfo: {
    statusType: "",
    statusCode: "",
    statusFlag: "",
    statusNotes: "",
    statusReason: "",
    statusOverAll: "",
    reasonNotes: "",
    reasonCode: "",
    reasonStatus: ""
  },
  freeFieldsInfo: {
    freeField1: "",
    freeField2: "",
    freeField3: "",
    freeField4: "",
    freeField5: ""
  }
};
